// Funciones de usuarios y sus guías.
// index.js las pone en el state: se usan como this.$store.state.<función>(...). Son métodos, así que `this` es el state.
import { db } from "@/firebase";
import { doc, getDoc, query, collection, where, getDocs, setDoc, limit } from "firebase/firestore";
import localforage from "localforage";
import { datosFaltantes } from "@/utils/perfil";
import { colecciones } from "../constantes";

export const funcionesUsuarios = {
  // Funciones de consulta recurrentes
  async obtenerUsuario(id, modoSinConexion) {
    if (modoSinConexion) {
      const usuario = await localforage.getItem(
        colecciones.localforage.usuarios.local,
      );
      return usuario ? usuario : null;
    } else {
      try {
        const docRef = doc(db, "riskmann_usuarios", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          return docSnap.data();
        } else {
          console.warn(`Usuario con ID ${id} no encontrado.`);
          return null;
        }
      } catch (error) {
        console.error(`Error al obtener usuario con ID ${id}:`, error);
        return null;
      }
    }
  },
  // Funciones de consulta recurrentes
  async obtenerUsuarios(coleccion) {
    try {
      let usuarios = [];
      const q = query(
        collection(db, coleccion ? coleccion : "riskmann_usuarios"),
      );
      const querySnapshot = await getDocs(q);
      querySnapshot.forEach((doc) => {
        usuarios.push({ ...doc.data() });
      });
      return usuarios;
    } catch (error) {
      console.error(`Error al obtener usuarios`, error);
      return null;
    }
  },
  async obtenerGuia(idUsuario) {
    const q = query(
      collection(db, "riskmann_guias_app"),
      where("idUsuario", "==", idUsuario),
      limit(1),
    );
    const querySnapshot = await getDocs(q);
    return querySnapshot.docs.length > 0
      ? querySnapshot.docs[0].data()
      : null;
  },
  // CREAR GUIA DE USUARIO DE APP
  async crearGuia(guia) {
    const refGuia = doc(collection(db, "riskmann_guias_app"));
    guia.id = refGuia.id;
    await setDoc(doc(db, "riskmann_guias_app", guia.id), guia);
  },
  // Los mismos datos obligatorios que Mi Perfil muestra como «Te faltan…» (src/utils/perfil.js)
  async validarDatosUsuario(id) {
    let usuario = await this.obtenerUsuario(id);
    return usuario ? datosFaltantes(usuario).length === 0 : false;
  },
};
